import React, { useMemo } from "react";
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  extractAgendaMeetingLinks,
  linkifyDescriptionSegments,
} from "../../utils/agendaMeetingLinks";

export default function AgendaEventDescription({ description, location, meetingLinks }) {
  const { t } = useTranslation("teamAgenda");

  const primaryUrls = useMemo(() => {
    const urls = extractAgendaMeetingLinks({ description, location, meetingLinks }).map((l) => l.url);
    return new Set(urls);
  }, [description, location, meetingLinks]);

  const segments = useMemo(
    () => linkifyDescriptionSegments(description, primaryUrls),
    [description, primaryUrls]
  );

  if (!segments.length) return null;

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.75 }}>
        {t("fieldDescription")}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        sx={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          color: "text.primary",
          lineHeight: 1.55,
          p: 1.25,
          borderRadius: 1.5,
          bgcolor: "action.hover",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {segments.map((seg, i) =>
          seg.type === "link" ? (
            <Link
              key={`${seg.href}-${i}`}
              href={seg.href}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontWeight: 500 }}
            >
              {seg.value}
            </Link>
          ) : (
            <span key={i}>{seg.value}</span>
          )
        )}
      </Typography>
    </Box>
  );
}
